import { pathJoin } from 'src/reducers/routing/utils'

export const createDetailRoutesMap = (prefix: string) => ({
  overview: pathJoin(prefix)('overview').chain,
  history: pathJoin(prefix)('history').chain,
})
